export default __webpack_public_path__ + "static/media/ibcLogoNew.b3e60806.svg";